import type { FullLocale } from '@/shared/locale'
import { formatGlobalDate } from 'shared/utils/formatters/dateCommonFormatter'

export type CommonDateFormatterWithTimeZone = CommonDateFormatter & Record<string, unknown>
export type CommonDateFormatter = {
  (date: Date | string, format?: string): string
  (date: null | undefined, format?: string): null
  (date: Date | string | null | undefined, format?: string): string | null
}

type FormatDate<TimeZone extends boolean> = TimeZone extends true
  ? CommonDateFormatterWithTimeZone
  : CommonDateFormatter

export const getFormatDate = <TimeZone extends boolean>(
  locale: FullLocale,
  timeZone: string | undefined,
): FormatDate<TimeZone> => {
  function formatDate(date: Date | string, format?: string): string
  function formatDate(date: null | undefined, format?: string): null
  function formatDate(date: Date | string | null | undefined, format?: string): string | null
  // eslint-disable-next-line func-style
  function formatDate(date: Date | string | null | undefined, format?: string): string | null {
    if (!date) {
      return null
    }

    const dateObj = typeof date === 'string' ? new Date(date) : date
    return formatGlobalDate(dateObj, locale, timeZone, format)
  }

  return formatDate as FormatDate<TimeZone>
}
